interface Props {
  actionMenu?: JSX.Element;
  addShadow?: boolean;
  children?: JSX.Element | string | undefined;
  className?: string;
  footer?: JSX.Element | string | undefined;
  hoverable?: boolean;
  imageHeight?: number;
  imageUrl?: string | undefined;
  loading?: boolean;
  movable?: boolean;
  moveByHandle?: boolean;
  subtitle?: JSX.Element | string | undefined;
  title?: JSX.Element | string | undefined;
}

const Container = ({
  actionMenu,
  addShadow,
  children,
  className,
  footer,
  hoverable = false,
  imageHeight = 180,
  imageUrl = '',
  loading = false,
  movable = false,
  moveByHandle = false,
  subtitle,
  title,
}: Props) => {
  return (
    <div className={className}>
      <raul-container
        // @ts-expect-error: children "does not exist on type"
        // eslint-disable-next-line react/no-children-prop
        children={
          loading ? (
            <raul-container-loader />
          ) : (
            <div className="r-h-full">
              {imageUrl && (
                <raul-container-image
                  height={imageHeight}
                  // @ts-expect-error: slot "does not exist on type"
                  slot="container-image"
                  src={imageUrl}
                />
              )}
              {(title || subtitle || actionMenu) && (
                <raul-container-header>
                  {title && (
                    <raul-container-title>{title}</raul-container-title>
                  )}
                  {subtitle && (
                    <raul-container-subtitle>
                      {subtitle}
                    </raul-container-subtitle>
                  )}
                  {actionMenu && (
                    <raul-container-header-actions
                      // @ts-expect-error: slot and children "does not exist on type"
                      // eslint-disable-next-line react/no-children-prop
                      children={actionMenu}
                      slot="container-header-actions"
                    />
                  )}
                </raul-container-header>
              )}
              {children && (
                <raul-container-body>{children}</raul-container-body>
              )}
              {footer && (
                <raul-container-footer>{footer}</raul-container-footer>
              )}
            </div>
          )
        }
        add-shadow={addShadow}
        hoverable={hoverable}
        movable={movable}
        move-by-handle={moveByHandle}
      />
    </div>
  );
};

export default Container;
